<template>
  <div class="home-page">
    <el-card shadow="never" class="update-card">
      <div slot="header" class="update-header">
        <span class="update-title">
          <i class="el-icon-time"></i>
          最近更新
        </span>
      </div>
      <el-timeline>
        <el-timeline-item
          v-for="(item, idx) in updateList"
          :key="idx"
          :timestamp="item.date"
          :color="item.color || '#409EFF'"
          placement="top"
        >
          <div class="update-item-title">
            <el-tag
              v-if="item.tag"
              :type="item.tagType || 'primary'"
              size="mini"
              effect="light"
              disable-transitions
              class="update-tag"
            >
              {{ item.tag }}
            </el-tag>
            <span>{{ item.title }}</span>
          </div>
        </el-timeline-item>
      </el-timeline>
    </el-card>
  </div>
</template>
<script>
/**
 * 系统首页"最近更新"时间线页面
 * 功能：静态展示 2026-05-13 的 Amazon AI 回复相关更新记录。
 * 备注：另有 4 条被注释掉的更新项（疑似弃用内容未清理）；created/methods 均为空实现。
 */
export default {
  data() {
    return {
      // 更新记录列表（静态数据，含被注释的弃用条目）
      updateList: [
        {
          date: "2026-08-28",
          tag: "新增",
          tagType: "success",
          color: "#67C23A",
          title: "基础配置新增Outlook邮箱授权",
        },
        {
          date: "2026-05-13",
          tag: "新增",
          tagType: "success",
          color: "#67C23A",
          title: "Amazon 已发送列表新增「是否 AI 回复」筛选与列展示",
        },
        {
          date: "2026-05-13",
          tag: "新增",
          tagType: "success",
          color: "#67C23A",
          title:
            "Amazon 收件箱新增「AI 回复状态」筛选与列展示；邮件详情新增 AI 智能回复",
        },
        // {
        //   date: "2026-05-13",
        //   tag: "优化",
        //   tagType: "warning",
        //   color: "#E6A23C",
        //   title: "AI 回复详情页中英文编辑区样式优化",
        // },
        // {
        //   date: "2026-05-13",
        //   tag: "新增",
        //   tagType: "success",
        //   color: "#67C23A",
        //   title: "新增 AI 智能回复邮件详情页",
        // },
      ],
    };
  },
  created() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.home-page {
  padding: 20px;
}

.update-card {
  width: 50%;
  min-width: 480px;

  ::v-deep .el-card__header {
    padding: 14px 20px;
    background: #f5f7fa;
  }
}

.update-header {
  display: flex;
  align-items: center;

  .update-title {
    font-size: 16px;
    font-weight: bold;
    color: #303133;

    i {
      margin-right: 6px;
      color: #409eff;
    }
  }
}

.update-item-title {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #303133;

  .update-tag {
    margin-right: 8px;
  }
}
</style>
